(function () {
  'use strict';

  function init() {
    var bundleRoot = document.querySelector('[data-product-bundle]');
    if (!bundleRoot) return;

    bundleRoot.querySelectorAll('[data-bundle-btn]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        addBundleToCart(btn, bundleRoot);
      });
    });
  }

  function openCartDrawer() {
    var cartBtn = document.querySelector(
      '#cart-icon-bubble, [data-cart-toggle], .js-cart-trigger, [href="/cart"]'
    );
    if (cartBtn) cartBtn.click();
  }

  function updateCartBadge(count) {
    document.querySelectorAll(
      '[data-cart-count], .cart-count, #cart-icon-bubble .cart-count-bubble span'
    ).forEach(function (el) { el.textContent = count; });
  }

  function addBundleToCart(btn, bundleRoot) {
    var mainVariantId      = btn.dataset.mainVariantId || bundleRoot.dataset.mainVariantId;
    var companionVariantId = btn.dataset.companionVariantId;

    if (!mainVariantId || !companionVariantId) {
      console.error('[Bundle] Faltan IDs de variante', {
        mainVariantId: mainVariantId,
        companionVariantId: companionVariantId
      });
      return;
    }

    btn.disabled = true;

    // Primero consultamos el carrito actual
    var checkXhr = new XMLHttpRequest();
    checkXhr.open('GET', '/cart.js', true);
    checkXhr.setRequestHeader('Accept', 'application/json');

    checkXhr.onload = function () {
      if (checkXhr.status !== 200) {
        btn.disabled = false;
        return;
      }

      var cart;
      try { cart = JSON.parse(checkXhr.responseText); } catch (e) {
        btn.disabled = false;
        return;
      }

      // Verificar si mainVariant y companionVariant ya están en el carrito
      var mainInCart      = cart.items.some(function (item) {
        return String(item.variant_id) === String(mainVariantId);
      });
      var companionInCart = cart.items.some(function (item) {
        return String(item.variant_id) === String(companionVariantId);
      });

      if (mainInCart && companionInCart) {
        // Bundle ya en carrito — solo abrir drawer
        updateCartBadge(cart.item_count);
        openCartDrawer();
        btn.disabled = false;
        return;
      }

      // No está en carrito — añadir
      var bundleId = 'bnd_' + Date.now();

      var payload = {
        items: [
          {
            id: parseInt(mainVariantId, 10),
            quantity: 1,
            properties: {
              _bundle_id:   bundleId,
              _bundle_role: 'main'
            }
          },
          {
            id: parseInt(companionVariantId, 10),
            quantity: 1,
            properties: {
              _bundle_id:           bundleId,
              _bundle_role:         'companion',
              _bundle_mode:         btn.dataset.mode || 'none',
              _bundle_discount_pct: btn.dataset.discountPct || '0'
            }
          }
        ]
      };

      var addXhr = new XMLHttpRequest();
      addXhr.open('POST', '/cart/add.js', true);
      addXhr.setRequestHeader('Content-Type', 'application/json');
      addXhr.setRequestHeader('Accept', 'application/json');

      addXhr.onload = function () {
        if (addXhr.status >= 200 && addXhr.status < 300) {

          var cartXhr = new XMLHttpRequest();
          cartXhr.open('GET', '/cart.js', true);
          cartXhr.setRequestHeader('Accept', 'application/json');

          cartXhr.onload = function () {
            if (cartXhr.status === 200) {
              try {
                var updatedCart = JSON.parse(cartXhr.responseText);
                updateCartBadge(updatedCart.item_count);
              } catch (e) {}
            }
            openCartDrawer();
            btn.disabled = false;
          };

          cartXhr.onerror = function () {
            openCartDrawer();
            btn.disabled = false;
          };

          cartXhr.send();

        } else {
          var err = {};
          try { err = JSON.parse(addXhr.responseText); } catch (e) {}
          console.error('[Bundle] Error al añadir:', err.description || addXhr.responseText);

          var errorEl = document.createElement('p');
          errorEl.style.cssText = 'color:red;font-size:0.85rem;margin-top:0.5rem;';
          errorEl.textContent = err.description || 'Error al añadir. Inténtalo de nuevo.';
          btn.parentNode.insertBefore(errorEl, btn.nextSibling);
          setTimeout(function () { errorEl.remove(); }, 4000);

          btn.disabled = false;
        }
      };

      addXhr.onerror = function () {
        console.error('[Bundle] Error de red');
        btn.disabled = false;
      };

      addXhr.send(JSON.stringify(payload));
    };

    checkXhr.onerror = function () {
      btn.disabled = false;
    };

    checkXhr.send();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();